<template>
    <div class="mmm">
        <header>
            <h1>
                <span>
                <router-link :to="'/video/disv/'+item.b_id" class='huiqu' v-for="(item,index) in book_list" :key="index">
                    <v-icon name="chevron-left" class="set_2"></v-icon>
                </router-link>
                </span>
            </h1>
            <div v-for="item in bookpartlist" style="width:100%;height:300px;">
              <p class="vtitle">{{item.bp_title}}</p>
              <video :src="'http://ts.winwulian.com/upload/'+item.bp_upload" controls="controls" preload="preload" width="100%" height="260"></video>
            </div>
           <div class="dis_endx">
        <div class="ed_va">
          <div class="dis_x"></div>
          <p class="ed_vp">章节列表</p>
        </div>
        <div class="ed_vcnt" >
                
          <div class="ed_vcntx" v-for="item in bookpartlist" >
                    <!-- <router-link :to="'/video/playm/'+[item.book_id,item.bp_id]" class='huiqu'> -->
            <v-icon name="file" class="dis_filex"></v-icon>
            <p>{{item.bp_title}}</p>
            <div class="ed_vcnt1">
              <v-icon name="volume-up" class="dis_bell"></v-icon>
              <span>{{item.bp_play_num}}</span>&nbsp;&nbsp;&nbsp;
              <v-icon name="clock" class="dis_clock"></v-icon>
              <span>{{item.bp_timelength}}</span>&nbsp;&nbsp;&nbsp;   
            </div>
            <p class="ed_vcnt2">{{item.moeny}}{{item.bp_price}}</p> 
                         <!-- </router-link> -->
          </div>
                   
          </div>
          <!-- 没有了 -->
<!--           <div class="ed_vcntx text_axc">
            <p>没有更多了...</p>
          </div> -->
        </div>
        </header>
    </div>
</template>
<script>
import appNav from "../common/appNav";
import { CURL } from "../../lib/url.js";
import $ from 'jquery';
export default {
  components: {
    appNav
  },
   data() {
      return {
        params: '',
        str:'',
        book_list:[],
        bookpartlist:[]
      }
    },
    created(){
      var param = this.$route.params.id;
      this.params = param.split(',')
      },
  mounted(){
    setTimeout(function(){
      $('.loading').remove()
    },1000)
    this.getAjax();
  },
    methods:{
            getAjax:function () {
             var openid= localStorage.getItem('openid')
             var successCallback =  (response) => {
                console.log('服务器请求成功了')
                console.log(response)
                if(response){
                  this.book_list = response.booklist
                  this.bookpartlist = response.bookpartlist
                  var str = response.bookpartlist.bp_upload
                }
               console.log(this.params)
              }
              var errorCallback =  (response) => {
                  console.log('服务器请求出错了')
              }
              this.$http.get(CURL+'/portal/All/getshipart?book_id='+this.params[0]+'&bp_id='+this.params[1],{
                data:{}
              }).then(successCallback,errorCallback);

              this.$http.get(CURL+'/portal/All/getplaynum?part_id='+this.params[1]+'&openid='+openid,{
                data:{}
              }).then(successCallback,errorCallback);
            }
          }

          
};

</script>
<style lang="scss" scoped>
.vtitle{
  height: 30px;
  line-height: 30px;
  width: 100%;
  padding-left: 25px;
  background-color: #d2f2dd;
  color: #777;
}
/*head*/
.mp3{
    margin-top: 1.2rem;
    float: left;
    width: 100%;
    margin-bottom: 2.33rem;
}
header{
    position: fixed;
    height: .4rem;
    background:url(../../img/ss.png);
    background-size:100% 100%;
    background-repeat: no-repeat;
    float: left;
    width: 100%;
}
.set_1{
    text-align: center;
    float: left;
    width: 80%;
    line-height: .4rem;
    font-weight: 600;
    color: #FFFFFF;
    font-size: 19px;
}
.set_2{
    float: left;
    margin-left: 3%;
    margin-top: 12px;
    width: 5%;
    color: #FFFFFF;
}


.dis_endx{
  margin-top: 30px;
}
.dis_endx,.ed_vcnt{
  float: left;
  width: 100%;
}
.ed_vp{
  float: left;
  width: 40%;
  padding-left: 15px;
}
.ed_va{
  width: 100%;
  float: left;
}
.dis_x{
  margin-top: 4px;
  float: left;
  width: 20px;
  height: 10px;
  background-color: #bad565;  
}
.dis_cntc{
  margin-top: 10px;
  padding: 0 15px 0 15px;
  float: left;
  width: 100%;
  p{
    line-height: 20px;
  }
}
/*cont*/
#cnt_butd{
  margin-left: 13%;
  border-bottom: #00a8d9 solid 2px;
  margin-right: 15px;
  color: #00a8d9;
}
.cnt_butxa{
  margin-right: 15px;
  margin-left: 15px;
}
.cnt_butxb{
  margin-left: 15px;
}
.dis_xx{
  margin-top: 4px;
  float: left;
  width: 1px;
  height: 10px;
  background-color: #777;
}
.cnt_butx,.cnt_butxa,.cnt_butxb{
  float: left;
  background-color: inherit;
  padding-bottom: 5px;
  font-weight: 500;
  text-align: center;
  width: 20%;
  color: #777;
}
.dis_cnt{
  margin-top: 15px;
  float: left;
  width: 100%;
}
/*conthead*/
.dis_xxx{
  margin-top: 9px;
  float: left;
  width: 1px;
  height: 10px;
  background-color: #777;
}
.dis_heart,.dis_up,{
  width: 10px;
  padding-top: 6px;
  margin-right: 5px;
}
.dis_hadebut{
  border: #777 solid 1px;
  padding: 5px 10px 5px 10px;
  background-color: #FFFFFF;
  border-radius: 8px;
  font-size: 12px;
  color: #777;
}
.dis_haddbut{
  padding: 5px 10px 5px 10px;
  background-color: #00a8d9;
  color: #FFFFFF;
  border-radius: 8px;
  font-size: 12px;
}
.dis_hada{
  margin-top: 2px;
  text-align: center;
  width: 14%;
  float: left;
  color: #777;
}
.dis_hadb{
  margin-top: 2px;
  text-align: center;
  width: 15%;
  float: left;
  color: #777;
}
.dis_hadc{
  margin-top: 5px;
  width: 12%;
  float: left;
  color: #00a8d9;
}
.dis_hadd,.dis_hade{
  text-align: center;
  width: 25%;
  float: left;
}
.dis_heada{
  width: 100%;
  float: left;
}
/**/
.dis_clone,.dis_clock,.dis_bell{
  width: 10px;
  padding-top: 5px;
  color: #00a8d9;
}
.dish_p1{
  font-size: 14px;
  margin-bottom: 5px;
  margin-top: 5px;
}
.dish_p2,.dish_p3,.dish_p4,.dish_p5,.dish_p6{
  color: #888;
}
.dish_cnth{
  float: left;
  width: 68%;
}
.dish_img{
  width: 23%;
  height: 118px;
  margin: 0 16px 0 10px;
  float: left;
}
.dis_head{
  width: 100%;
  float: left;
  margin-top: 15px;
}
.dis_cont{
  float: left;
  width: 100%;
  margin-top: .4rem;
}
.ed_vcntx{
  margin-top: 15px;
  float: left;
  width: 100%;
  border-bottom: #ccc solid 2px;
  padding-bottom: 10px;
}
.dis_filex{
  margin-left: 15px;
  float: left;
  height: 100%;
  width: 21px;
  color: #00a8d9;
  margin-right: 15px;
}
.ed_vcnt2{
  float: right;
  color: #00a8d9;
  margin-right: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/video/playm.vue